import * as isvek from '../../../vendor/assets/javascripts/bvi/dist/js/bvi.js'

document.addEventListener("DOMContentLoaded", function () {
    new isvek.Bvi({ builtElements: true, reload: true, panelFixed: false, fontSize: 16 })
})
